<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺名称')" prop="shopId">
                <a-input
                  v-model="queryParam.shopNamne"
                  :maxLength="32"
                  :placeholder="$t('通用.输入.请输入') + $t('店铺名称')"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"
                  ><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery"
                  ><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button
                >
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['shop:renewrecord:add']">
          <a-icon type="plus" />{{ $t('通用.按钮.新增') }}
        </a-button> -->
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['shop:renewrecord:edit']"
        >
          <a-icon type="edit" />{{ $t('审核') }}
        </a-button>
        <!-- <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['shop:renewrecord:remove']">
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['shop:renewrecord:export']">
          <a-icon type="download" />{{ $t('通用.按钮.导出') }}
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :scroll="{ x: 1500 }"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="shopProtocol" slot-scope="text, record">
          <div>
            <img
              v-if="record.shopProtocol"
              :src="record.shopProtocol"
              style="width: 60px; height: 62px"
              @click="handleRecordPreview(record.shopProtocol)"
              alt="none"
            />
          </div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['shop:renew/record:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shop:renew/record:edit']">
            <a-icon type="edit" />{{ $t('审核') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRenewRecord, listRenewRecord, delRenewRecord } from '@/api/shop/renewRecord'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'RenewRecord',
  components: {
    CustomDictTag,
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        shopId: undefined,
        bankUserPhone: undefined,
        bankAccountName: undefined,
        bankName: undefined,
        bankAddress: undefined,
        accountInstCity: undefined,
        accountInstProvince: undefined,
        bankAccountNumber: undefined,
        moneyBzj: undefined,
        shopProtocol: undefined,
        status: undefined,
        reason: undefined,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: this.$t('店铺名称'),
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center',
          fixed: 'left',
          width: 150,
        },
        {
          title: this.$t('银行预留手机号'),
          dataIndex: 'bankUserPhone',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('银行开户名'),
          dataIndex: 'bankAccountName',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('开户银行支行名称'),
          dataIndex: 'bankName',
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('开户银行所在地'),
          dataIndex: 'bankAddress',
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('开户行城市'),
          dataIndex: 'accountInstCity',
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('开户行省份'),
          dataIndex: 'accountInstProvince',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('公司银行账号'),
          dataIndex: 'bankAccountNumber',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('保证金'),
          dataIndex: 'moneyBzj',
          ellipsis: true,
          align: 'center',
          width: 110,
        },
        {
          title: this.$t('打款备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('打款截图'),
          dataIndex: 'shopProtocol',
          ellipsis: true,
          align: 'center',
          width: 130,
          scopedSlots: { customRender: 'shopProtocol' },
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          width: 120,
          customRender: (value) => {
            //0 待审核 1审核成功 2拒绝
            if (value === '0') {
              return this.$t('待审核')
            } else if (value === '1') {
              return this.$t('审核成功')
            } else {
              return this.$t('拒绝')
            }
          },
        },
        {
          title: this.$t('失败原因'),
          dataIndex: 'reason',
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: 100,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询店铺续费申请记录列表 */
    getList() {
      this.loading = true
      pageRenewRecord(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        shopId: undefined,
        bankUserPhone: undefined,
        bankAccountName: undefined,
        bankName: undefined,
        bankAddress: undefined,
        accountInstCity: undefined,
        accountInstProvince: undefined,
        bankAccountNumber: undefined,
        moneyBzj: undefined,
        shopProtocol: undefined,
        status: undefined,
        reason: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delRenewRecord(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            const message = that.$t('通用.文本.删除成功')
            that.$message.success(message, 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('shop/renew/record/export', ...that.queryParam, `店铺续费申请记录_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },
  },
}
</script>